import moment from 'moment-mini'

import { Injectable } from '@angular/core'

import { OperationInternalEvent } from './operation-internal-event'

@Injectable()
export class OperationInternalEventSerializer {
  fromJson(json: any): OperationInternalEvent {
    const operationInternalEvent = {
      ...json
    }

    return operationInternalEvent
  }

  toJson(operationInternalEvent: OperationInternalEvent): any {
    return {
      ...operationInternalEvent
    }
  }
}
